import React from "react";

const Attractions = ({ data }) => {
  const { table_description, description_color, table_head, table_body } = data;
  return (
    <div className="bg-[#e6ebf0] px-8 py-[2.56vw]">
      <div className="container mx-auto">
        {/* Title */}
        <h2
          className="text-[4.7vw] md:text-[2.35vw] text-center font-redhatMedium"
          style={{ color: description_color }}
        >
          {table_description?.data?.table_description ||
            "Iconic Delhi Attractions"}
        </h2>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="w-[225vw] md:w-full table-auto text-left border-separate border-spacing-y-2">
            <thead>
              <tr className="text-[#000] font-bold">
                {table_head.map((head, idx) => (
                  <th key={idx} className="pt-[0.56vw] text-[4.7vw] md:text-[1.6vw] font-redhatBold">
                    {head.title}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody className="text-[#333]">
              {table_body.map((row, rowIndex) => (
                <tr key={rowIndex} className="">
                  {row.body_content.map((cell, colIndex) => {
                    const text = cell?.text_desc?.data?.text_desc || "";
                    return (
                      <td
                        key={colIndex}
                        className={`p-[0.46vw] border-t border-[#AEAEB2] text-[#000] text-[3.8vw] md:text-[1.19vw]   ${
                          colIndex === 0 ? "font-redhatBold" : "font-redhatRegular"
                        }`}
                      >
                        {text}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Attractions;
